import { apiRequest } from '@/shared/api';

import type { RewardTrack } from '../model/types';

export function fetchRewardTrack(): Promise<RewardTrack> {
  return apiRequest<RewardTrack>('/reward-track');
}
